import React from 'react';
import { detectLocaleClient } from 'helpers/i18n/detectLocale';
import { I18N_DEFAULT_NAMESPACE } from '../constants';
import { createI18N } from '../createI18N';
import { I18NProvider, LocaleProvider } from '.';
import { SupportedLocales } from '../types';

// This component makes the wrapping of needed providers in the client for i18n,
// and also the hydration of translations in i18next instance to match what the server sends.
// The server will use withI18N HoC (client/i18n/withI18N.tsx) to provide the contexts
const detectedLocale = detectLocaleClient() as SupportedLocales;
const i18n = createI18N();

if (detectedLocale) {
  // As per i18next docs (https://www.i18next.com/overview/api#cloneinstance)
  // the clone of an i18next instance will share store (where translations are),
  // plugins and initial config with the original instance. We change the language
  // in the clone to just touch the store of the original instance
  const clone = i18n.cloneInstance();
  clone.changeLanguage(detectedLocale);
  clone.loadNamespaces(I18N_DEFAULT_NAMESPACE);
}

export const I18NClientProvider = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <LocaleProvider locale={detectedLocale}>
      <I18NProvider i18n={i18n}>{children}</I18NProvider>
    </LocaleProvider>
  );
};
